import './App.css';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom";
import Navbar from './components/Navbar';
import Start from './subpages/Start';
import Spendenziel from './subpages/Spendenziel';
import Spendenempfaenger from './subpages/Spendenempfaenger';
import Preisliste from './subpages/Preisliste';
import Unterstuetzen from './subpages/Unterstuetzen';
import Mitmachen from './subpages/Mitmachen';
import MitmachenAusverkauft from './subpages/MitmachenAusverkauft';
import Lions from './subpages/Lions';
import Teilnahmeregeln from './subpages/Teilnahmeregeln';
import ScrollToTop from './components/ScrollToTop';
import Impressum from './subpages/Impressum';
import Datenschutz from './subpages/Datenschutz';
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import ReactGA from "react-ga4";
import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'
import React, { useEffect, useMemo } from 'react';

import UtilAnalytics from "./components/Analytics";
import useSeasonDetails from "./hooks/useSeasonDetails";



const menuLinks = [
    {
        name: "Impressum",
        link: "/impressum",
        view: Impressum,
        hiddenInMenu: true,
    },
    {
        name: "Datenschutz",
        link: "/datenschutz",
        view: Datenschutz,
        hiddenInMenu: true
    },
    {
        name: "Teilnahmeregeln",
        link: "/teilnahmeregeln",
        view: Teilnahmeregeln,
        hiddenInMenu: true
    },
    {
        name: "Spendenempfänger",
        link: "/spendenempfaenger",
        view: Spendenempfaenger,
        hiddenInMenu: true
    },
    {
        name: "Start",
        link: "/",
        view: Start,
        exact: true
    },
    {
        name: "Spendenziel",
        link: "/spendenziel",
        view: Spendenziel
    },
    {
        name: "Preisliste",
        link: "/preisliste",
        view: Preisliste,
        showWhen: "show-preisliste",
    },
    {
        name: "Gewinnerliste",
        link: "/preisliste",
        view: Preisliste,
        showWhen: "show-gewinnerliste",
    },
    {
        name: "Unterstützen",
        link: "/unterstuetzen",
        view: Unterstuetzen
    },
    {
        name: "Lions",
        link: "/lions",
        view: Lions
    },
    {
        name: "Mitmachen",
        link: "/mitmachen",
        view: MitmachenAusverkauft
    }
]

const handleAcceptCookie = () => {
    UtilAnalytics.handleAcceptCookie()
}

function App() {
    const { data } = useSeasonDetails();

    const menu = useMemo(
        () =>
            menuLinks.map((item) => {
                if (item.showWhen && data?.[item.showWhen] === false) {
                    return { ...item, hiddenInMenu: true };
                }
                if (item.showWhen === "show-preisliste" && data?.["show-gewinnerliste"] === true) {
                    return { ...item, hiddenInMenu: true };
                }
                return item;
            }),
        [data]
    );

    useEffect(() => {
        const isConsent = getCookieConsentValue();
        if (isConsent === "true") {
            handleAcceptCookie();
        }
    }, []);
    return (
        <div className="App">
            <CookieConsent
                buttonText="Zulassen"
                buttonStyle={{ background: "white", color: "black", margin: "15px 15px 15px 0px" }}
                declineButtonText="Ablehnen"
                declineButtonStyle={{ background: "white", color: "black" }}
                style={{ background: "rgba(255, 170, 0, 1)", }}
                enableDeclineButton
                onAccept={handleAcceptCookie}
            >
                Wir verwenden Cookies, um die Zugriffe auf unsere Website zu analysieren. Erfahren Sie in unserer Datenschutzrichtlinie mehr darüber.
            </CookieConsent>
            <Router>
                <Navbar
                    menu={menu}
                    ausverkauftText={
                        data?.["show-ausverkauft"]
                            ? data?.["ausverkauft-text"]
                            : null
                    }
                />
                <ScrollToTop />
                <Switch>
                    {menu.map((item, index) => {
                        return (
                            <Route exact={item.exact} path={item.link} key={index} component={item.view}>
                                {/* {item.view} */}
                            </Route>
                        )
                    })}
                    <Redirect to='/' />
                </Switch>

            </Router>
        </div>
    );
}

export default App;
